import React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { SidebarContent } from '../sidebar';
import type { SidebarItem } from '../sidebar';
import { MobileBar } from './mobile-bar';

interface MobileNavDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: SidebarItem[];
  onItemClick: (item: SidebarItem) => void;
}

export function MobileNavDrawer({
  open,
  onOpenChange,
  items,
  onItemClick,
}: MobileNavDrawerProps): React.ReactElement {
  const { t } = useTranslation('cabinet');

  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-foreground/20 backdrop-blur-sm data-[state=closed]:animate-fade-out data-[state=open]:animate-fade-in lg:hidden" />

        <DialogPrimitive.Content
          className="fixed inset-y-0 left-0 z-50 flex h-[100dvh] w-full max-w-sm flex-col bg-background pt-[var(--layout-header-padding-top-mobile,16px)] shadow-xl outline-none will-change-transform data-[state=closed]:animate-slide-out-left data-[state=open]:animate-slide-in-left lg:hidden"
          aria-label={t('header.menu')}
          aria-describedby={undefined}
        >
          <DialogPrimitive.Title className="sr-only">{t('header.menu')}</DialogPrimitive.Title>

          <MobileBar
            leading={
              <DialogPrimitive.Close
                aria-label={t('header.closeMenu')}
                className="flex size-tap shrink-0 items-center justify-center rounded-xl text-foreground transition-colors duration-fast ease-standard hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <X className="size-header-icon" />
              </DialogPrimitive.Close>
            }
          />

          <div className="flex-1 overflow-y-auto py-4">
            <SidebarContent
              items={items}
              onItemClick={(item) => {
                onItemClick(item);
                if (!item.children?.length) {
                  onOpenChange(false);
                }
              }}
            />
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
